import React, { PropsWithChildren } from 'react';
import { Grid } from '@mui/material';
import { paddingStyles } from '../../constants/theme/styles/layout/paddingStyles';
import { dividerSectionStyles } from '../../constants/theme/styles/layout/dividersection-styles';

interface Props {
    fullWidth?: boolean;
}


export const MainContent = (props: PropsWithChildren<Props>) => {
    const classes = paddingStyles();
    const dividerSectionClasses = dividerSectionStyles();
    return (
        <>
            <Grid container item md={props.fullWidth ? 12 : 8}>
                <Grid item xs={12} className={`main-content ${dividerSectionClasses.dividerSectionWrapper} ${props.fullWidth ? '' : classes.contentPadding}`}>
                    {props.children}

                </Grid>

            </Grid>
        </>
    );
};

MainContent.defaultProps = {
    fullWidth: false,
};